// extracted by mini-css-extract-plugin
module.exports = {"page":"style__page__RE-U5","body":"style__body__7vL2r","robot":"style__robot__SQB+d","preloadImages":"style__preloadImages__b+JpC"};